import {
  getActiviteId,
  toNumber,
  estReponseOuiNon,
  obtenirIdsUniques,
  obtenirNombreRestantsBloc,
  trouverDetailParId,
  obtenirLieuxDisponibles,
  aPlusDeLieuxDisponibles,
  blocLieuEstComplet,
  indexBlocAutreLieu,
} from './fermer-enregistrement-capture.js';

export function resolveGibierDescription(gibier) {
  return gibier.nom || gibier.Nom || gibier.description || gibier.Description || gibier.noGibier || gibier.no_gibier || gibier.NoGibier || '';
}

export function buildCaptureDetailsFromGibiers(gibiers) {
  return (gibiers || []).map(createEmptyCaptureDetail);
}

export function findActiviteChasse(activites) {
  return activites.find(a => a.chasse === true || a.chasse === 1);
}

export function findChasseEnregistrementDetail(enregistrement, activites) {
  const idActivitesChasse = activites
    .filter(a => a.chasse === true || a.chasse === 1)
    .map(a => getActiviteId(a));

  return (enregistrement?.enregistrementDetails || []).find(d => idActivitesChasse.includes(d.idActivite));
}

export function createEmptyCaptureDetail(gibier) {
  const idGibier = gibier.idGibier || gibier.IdGibier || gibier.id;
  return {
    idGibier,
    descriptionEspece: resolveGibierDescription(gibier),
    nombreCaptureRapportee: '',
    nombreCaptureConsommee: '',
    arme: '',
    noPermis: '',
    noCertificat: '',
    remarques: '',
    aCaptureRapportee: null,
    aCaptureConsommee: null,
  };
}

let secteurBlockCounter = 0;

export function aPlusieursGibiersCapture(capturesDetails) {
  return obtenirIdsGibiersCapture(capturesDetails).length > 1;
}

export function obtenirIdsGibiersCapture(capturesDetails) {
  return obtenirIdsUniques(capturesDetails, detail => detail.idGibier || '');
}

export function obtenirNombreGibiersRestants(block) {
  return obtenirNombreRestantsBloc(block, detail => detail.idGibier || '');
}

export function obtenirDetailGibierActif(block) {
  return trouverDetailParId(block.capturesDetails, block.activeEspeceId, detail => detail.idGibier || '');
}

export function questionsGibierActifCompletes(block) {
  return questionsDetailGibierCompletees(obtenirDetailGibierActif(block));
}

export function quantiteCaptureRapporteeCompletee(detail) {
  return detail.aCaptureRapportee !== true || Number(detail.nombreCaptureRapportee) > 0;
}

export function quantiteCaptureConsommeeCompletee(detail) {
  return detail.aCaptureConsommee !== true || Number(detail.nombreCaptureConsommee) > 0;
}

export function questionsDetailGibierCompletees(detail) {
  if (!detail) {
    return false;
  }
  if (!estReponseOuiNon(detail.aCaptureRapportee) || !quantiteCaptureRapporteeCompletee(detail)) {
    return false;
  }
  if (!estReponseOuiNon(detail.aCaptureConsommee) || !quantiteCaptureConsommeeCompletee(detail)) {
    return false;
  }
  if (!detail.arme) {
    return false;
  }
  return true;
}

function obtenirDetailGibierParId(block, gibierId) {
  return trouverDetailParId(block.capturesDetails, gibierId, detail => detail.idGibier || '');
}

export function fluxGibiersCaptureComplete(block) {
  const rounds = block.especeRounds || [];
  for (const round of rounds) {
    if (!questionsDetailGibierCompletees(obtenirDetailGibierParId(block, round.speciesId))) {
      return false;
    }
  }
  const activeId = String(block.activeEspeceId || '');
  if (activeId) {
    return questionsGibierActifCompletes(block);
  }
  return rounds.length > 0;
}

function definirReponseRound(especeRounds, roundIndex, valeur) {
  return especeRounds.map((round, i) =>
    i === roundIndex ? { ...round, autreEspece: valeur } : round
  );
}

export function verrouillerGibierActifSiComplete(block) {
  if (block.aEuDesPrises !== true) {
    return block;
  }
  if (!aPlusieursGibiersCapture(block.capturesDetails)) {
    return block;
  }
  const idActif = String(block.activeEspeceId || '');
  if (!idActif || !questionsGibierActifCompletes(block)) {
    return block;
  }

  const especeRounds = [...(block.especeRounds || [])];
  if (!especeRounds.some(round => String(round.speciesId) === idActif)) {
    especeRounds.push({ speciesId: idActif, autreEspece: null });
  }

  const blocSuivant = {
    ...block,
    especeRounds,
    activeEspeceId: '',
    autreEspece: null,
  };

  if (obtenirNombreGibiersRestants(blocSuivant) <= 0) {
    return {
      ...blocSuivant,
      especeRounds: definirReponseRound(especeRounds, especeRounds.length - 1, false),
      autreEspece: false,
    };
  }
  return blocSuivant;
}

export function montrerQuestionAutreGibierRound(block, roundIndex) {
  if (block.aEuDesPrises !== true) {
    return false;
  }
  if (!aPlusieursGibiersCapture(block.capturesDetails)) {
    return false;
  }
  const rounds = block.especeRounds || [];
  if (roundIndex < 0 || roundIndex >= rounds.length) {
    return false;
  }
  if (roundIndex < rounds.length - 1) {
    return true;
  }
  return obtenirNombreGibiersRestants(block) > 0 || Boolean(block.activeEspeceId);
}

export function obtenirReponseAutreGibierRound(block, roundIndex) {
  const round = (block.especeRounds || [])[roundIndex];
  if (!round || round.autreEspece === undefined) {
    return null;
  }
  return round.autreEspece;
}

export function doitAfficherSaisieGibierActive(block) {
  if (block.aEuDesPrises !== true) {
    return false;
  }
  if (!aPlusieursGibiersCapture(block.capturesDetails)) {
    return true;
  }
  if (block.activeEspeceId) {
    return true;
  }
  if ((block.especeRounds || []).length === 0) {
    return true;
  }
  if (obtenirNombreGibiersRestants(block) <= 0) {
    return false;
  }
  return block.autreEspece === true;
}

export function montrerListeDeroulanteGibier(block) {
  return doitAfficherSaisieGibierActive(block);
}

export function afficherListeDeroulanteGibierActive(block) {
  return doitAfficherSaisieGibierActive(block);
}

export function obtenirGibierActifInitial(capturesDetails) {
  const ids = obtenirIdsGibiersCapture(capturesDetails);
  return ids.length === 1 ? ids[0] : '';
}

export function estQuestionAutreGibierResolue(block) {
  if (block.aEuDesPrises !== true) {
    return true;
  }
  if (!aPlusieursGibiersCapture(block.capturesDetails)) {
    return questionsGibierActifCompletes(block);
  }
  if (block.activeEspeceId) {
    return false;
  }
  if ((block.especeRounds || []).length === 0) {
    return false;
  }
  if (block.autreEspece === false || obtenirNombreGibiersRestants(block) <= 0) {
    return fluxGibiersCaptureComplete(block);
  }
  return false;
}

export function appliquerChangementGibierActif(block, gibierId) {
  const nouvelId = String(gibierId || '');
  const idsRounds = (block.especeRounds || []).map(round => String(round.speciesId));
  const idsAConserver = nouvelId ? [...idsRounds, nouvelId] : idsRounds;

  return {
    ...block,
    activeEspeceId: nouvelId,
    capturesDetails: reinitialiserCapturesDetailsGibierExcept(block.capturesDetails, idsAConserver),
  };
}

export function reinitialiserDetailCaptureGibier(detail) {
  const idGibier = detail.idGibier || '';
  return createEmptyCaptureDetail({
    idGibier,
    description: detail.descriptionEspece,
  });
}

export function reinitialiserCapturesDetailsGibierExcept(capturesDetails, idsAConserver) {
  const conserver = new Set((idsAConserver || []).map(String));
  return (capturesDetails || []).map(detail => {
    const id = String(detail.idGibier || '');
    if (conserver.has(id)) {
      return detail;
    }
    return reinitialiserDetailCaptureGibier(detail);
  });
}

export function appliquerAutreGibierOui(block, roundIndex) {
  const blocVerrouille = verrouillerGibierActifSiComplete(block);

  if (blocVerrouille.activeEspeceId) {
    return block;
  }

  const rounds = blocVerrouille.especeRounds || [];
  const index = Number.isInteger(roundIndex) ? roundIndex : rounds.length - 1;
  if (index < 0 || index >= rounds.length) {
    return block;
  }

  if (index < rounds.length - 1) {
    return {
      ...blocVerrouille,
      especeRounds: definirReponseRound(rounds, index, true),
    };
  }

  if (obtenirNombreGibiersRestants(blocVerrouille) <= 0) {
    return {
      ...blocVerrouille,
      especeRounds: definirReponseRound(rounds, index, false),
      autreEspece: false,
    };
  }

  return {
    ...blocVerrouille,
    especeRounds: definirReponseRound(rounds, index, true),
    autreEspece: true,
    autreSecteur: null,
  };
}

export function appliquerAutreGibierNon(block, roundIndex) {
  const rounds = block.especeRounds || [];
  const index = Number.isInteger(roundIndex) ? roundIndex : rounds.length - 1;

  if (index < 0 || index >= rounds.length) {
    return {
      ...block,
      autreEspece: false,
      activeEspeceId: '',
    };
  }

  const especeRounds = definirReponseRound(rounds.slice(0, index + 1), index, false);
  const idsRounds = especeRounds.map(round => String(round.speciesId));

  return {
    ...block,
    autreEspece: false,
    activeEspeceId: '',
    especeRounds,
    capturesDetails: reinitialiserCapturesDetailsGibierExcept(block.capturesDetails, idsRounds),
  };
}

export function createEmptySecteurBlock() {
  secteurBlockCounter += 1;
  return {
    id: `sec-${secteurBlockCounter}`,
    idSecteur: '',
    nombrePersonnes: '',
    nombreJours: '',
    autreSecteur: null,
    autreEspece: null,
    especeRounds: [],
    activeEspeceId: '',
    aEuDesPrises: null,
    capturesDetails: [],
  };
}

export function getSecteursDisponibles(allSecteurs, secteurs, index) {
  return obtenirLieuxDisponibles(allSecteurs, secteurs, index, 'idSecteur');
}

export function hasMoreSecteursDisponibles(allSecteurs, secteurs) {
  return aPlusDeLieuxDisponibles(allSecteurs, secteurs, 'idSecteur');
}

export function shouldRenderSecteurBlock(block, index, allSecteurs, secteurs) {
  if (index === 0) {
    return true;
  }
  if (block.idSecteur) {
    return true;
  }
  const previousBlock = secteurs[index - 1];
  if (!previousBlock || previousBlock.autreSecteur !== true) {
    return false;
  }
  return getSecteursDisponibles(allSecteurs, secteurs, index).length > 0;
}

export function pruneOrphanSecteurBlocks(secteurs, allSecteurs) {
  return secteurs.filter((block, index) =>
    shouldRenderSecteurBlock(block, index, allSecteurs, secteurs)
  );
}

export function estComplete(block) {
  return blocLieuEstComplet(block, 'idSecteur');
}

export function getAutreSecteurBlockIndex(secteurs) {
  return indexBlocAutreLieu(secteurs, 'idSecteur');
}

export function afficherAutreSecteur(index, secteurs, allSecteurs) {
  const block = secteurs[index];
  if (!estComplete(block)) {
    return false;
  }
  if (block.aEuDesPrises === null) {
    return false;
  }
  if (!estQuestionAutreGibierResolue(block)) {
    return false;
  }
  if (block.autreSecteur !== null && block.autreSecteur !== undefined) {
    return true;
  }
  if (!hasMoreSecteursDisponibles(allSecteurs, secteurs)) {
    return false;
  }
  return index === getAutreSecteurBlockIndex(secteurs);
}

export function captureDetailHasQuantity(detail) {
  return Number(detail.nombreCaptureRapportee) > 0
    || Number(detail.nombreCaptureConsommee) > 0;
}

export function formEstComplete({ dateIsSelected, heureIsSelected, aChasse, secteurs, allSecteurs = [] }) {
  if (!dateIsSelected || !heureIsSelected || aChasse === null) {
    return false;
  }

  if (aChasse === false) {
    return true;
  }

  if (!secteurs.length) {
    return false;
  }

  for (let i = 0; i < secteurs.length; i++) {
    const block = secteurs[i];
    if (!block.idSecteur) {
      return false;
    }
    if (!block.nombrePersonnes || Number(block.nombrePersonnes) <= 0) {
      return false;
    }
    if (!block.nombreJours || Number(block.nombreJours) <= 0) {
      return false;
    }

    if (block.aEuDesPrises === null) {
      return false;
    }

    if (block.aEuDesPrises === true && !estQuestionAutreGibierResolue(block)) {
      return false;
    }
  }

  const autreSecteurBlockIndex = getAutreSecteurBlockIndex(secteurs);
  if (autreSecteurBlockIndex >= 0 && hasMoreSecteursDisponibles(allSecteurs, secteurs)) {
    const autreBlock = secteurs[autreSecteurBlockIndex];
    if (autreBlock.autreSecteur !== false) {
      return false;
    }
  }

  return true;
}

function mapCaptureDetailFields(detail) {
  return {
    IdEspece: '00000000-0000-0000-0000-000000000000',
    IdGibier: detail.idGibier,
    NombreCaptureRapportee: toNumber(detail.nombreCaptureRapportee),
    NombreCaptureConsommee: toNumber(detail.nombreCaptureConsommee),
    Arme: detail.arme || '',
    NoPermis: detail.noPermis || '',
    NoCertificat: detail.noCertificat || '',
    Remarques: detail.remarques || '',
  };
}

export function buildFermetureChasseCapturePayload({
  idProfile,
  dateFermetureISO,
  idEnregistrementEntete,
  idEnregistrementDetailChasse,
  aChasse,
  secteurs,
}) {
  return {
    IdProfile: idProfile,
    DateFermeture: dateFermetureISO,
    IdEnregistrementEntete: idEnregistrementEntete,
    ActivitesChasse: [{
      IdEnregistrementDetail: idEnregistrementDetailChasse,
      AChasse: aChasse === true,
      Secteurs: aChasse === true
        ? (secteurs || [])
          .filter(block => block.idSecteur)
          .map(block => ({
            IdSecteur: block.idSecteur,
            NombrePersonnes: toNumber(block.nombrePersonnes),
            NombreJours: toNumber(block.nombreJours),
            AEuDesPrises: block.aEuDesPrises === true,
            CapturesDetails: (block.capturesDetails || []).map(mapCaptureDetailFields),
          }))
        : [],
    }],
  };
}
